import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { filterMenuFontStyle, listFontStyle } from '../../content/shared/CommonFontSize';
import { heartbeatActions, heartbeatCall, heartbeatState } from '../../slices/heartbeatSlice';
import { useDispatch, useSelector } from 'react-redux';

import ActionButton from '../ActionButton.js/index.js';
import CancelButton from '../CancelButton';
import { InacivitySessionTimeout } from '../../appsettings';
import { deleteSession } from '../../slices/userSessionSlice';
import { loginLink } from 'src/router/routerLink';
import useAuth from '../../hooks/useAuth';
import { useNavigate } from 'react-router-dom';

const twoDigits = (num) => String(num).padStart(2, '0')
const InactivitySessionDialog = () => {
    const { logout } = useAuth();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { open } = useSelector(heartbeatState);
    const [secondsRemaining, setSecondsRemaining] = useState(InacivitySessionTimeout);
    const secondsToDisplay = secondsRemaining / 1000;

    useEffect(() => {
        secondsRemaining/10000 == 0.2 && handleLogout();
        open ? setTimeout(() => {
            setSecondsRemaining(secondsRemaining - 1000)
        }, 1000) :
        setSecondsRemaining(InacivitySessionTimeout);
    }, [open, secondsRemaining])

    const handleClose = () => { dispatch(heartbeatActions.openDialog(false)) }
    const handleLogout = async () => {
        dispatch(deleteSession())
            .unwrap()
            .then(async () => {
                sessionStorage.removeItem("SettingProfile");
                await logout();
                navigate(loginLink);
                handleClose();
            });
    }
    const handleContinue = () => {
        dispatch(heartbeatCall())
        handleClose();
    }

    return (
        <>
            <Dialog
                open={open}
                onClose={(_, reason) => {
                    if (reason !== "backdropClick") {
                        handleClose();
                    }
                }}
                sx={{ backdropFilter: "blur(5px)", }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{ style: { width: '350px', height: '150px', borderRadius: '2px', backgroundColor: '#2C314C', } }}
            >
                <DialogTitle
                    id="alert-dialog-title"
                    sx={{ ...listFontStyle, color: "#E6E7EB", fontWeight: "700", top: '16px', left: '16px' }}
                >
                    Session Expire Warning
                </DialogTitle>
                <DialogContent sx={{ overflowY: 'hidden' }}>
                    <DialogContentText
                        id="alert-dialog-description"
                        sx={{
                            ...filterMenuFontStyle,
                            fontWeight: "700",
                            letterSpacing: '0.32px'
                        }}
                    >
                        Your session will expire in {twoDigits(secondsToDisplay)} seconds. Do you want to continue the session?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <ActionButton
                        handleClick={() => handleContinue()}
                        label='Continue'
                        buttonStyle={{ width: '80px', marginRight: '5px' }}
                    />
                    <CancelButton
                        handleClick={handleLogout}
                        label='Logout'
                        disable={false}
                        buttonStyle={{ width: '80px', right: '16px' }}
                    />
                </DialogActions>
            </Dialog>
        </>
    )
}
export default InactivitySessionDialog;